module.exports = __webpack_public_path__ + "img/mobile_20250806.6dac9467.jpg";